import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./product/productSlice";
import productCategoryReducer from "./productCategory/productCategorySlice";
import orderReducer from "./order/orderSlice";
import authReducer from "./auth/authSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    order: orderReducer,
    product: productReducer,
    productCategory: productCategoryReducer,
    
  },
});

export default store;
